import { render, staticRenderFns } from "./EducationalPublicationPage.vue?vue&type=template&id=5787a4e6&scoped=true"
import script from "./EducationalPublicationPage.vue?vue&type=script&lang=js"
export * from "./EducationalPublicationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787a4e6",
  null
  
)

export default component.exports